module.exports = __webpack_public_path__ + "static/img/wechat.4f67a7a3.svg";